import { ID } from 'api'
import { Application } from 'api/application/types'
import getVCTextIdentifier from 'api/virtual-currency/utils'
import { graphql } from 'msw'
import db from '../db'

const applicationHandlers = [
  graphql.query('application', (req, res, ctx) => {
    const application = db.application.get(req.variables.id)
    return res(ctx.data({ application: application }))
  }),

  graphql.query('listApplications', (req, res, ctx) => {
    const publisherId = req.variables.publisherId as ID
    const applications = db.application.getAll(
      (app) => app.publisher.id === publisherId
    )

    return res(ctx.data({ applications }))
  }),

  graphql.mutation('createApplication', (req, res, ctx) => {
    const { publisherId, vcName, plName, plStatus, exchangeRate } =
      req.variables

    const publisher = db.publisher.get(publisherId)

    const application = db.application.create({
      ...(req.variables as Application),
      publisher,
    })

    const virtualCurrency = db.vc.create({
      name: vcName,
      isDefault: true,
      iconUrl: '',
      textIdentifier: getVCTextIdentifier(vcName),
      application,
    })

    const placement = db.placement.create({
      name: plName,
      isDefault: true,
      status: plStatus,
      tabsEnabled: false,
      turboEnabled: false,
      webOfwEnabled: false,
      application,
      virtualCurrency,
      exchangeRates: [exchangeRate],
      virtualCurrencySaleEnabled: false,
    })

    return res(ctx.data({ application, placement }))
  }),

  graphql.mutation('updateApplication', (req, res, ctx) => {
    const application = db.application.update(req.variables as Application)
    return res(ctx.data({ applicationUpdate: { application } }))
  }),
]

export default applicationHandlers
